import * as types from './types';

export const selectTag = payload => ({ type: types.SELECT_TAG, payload });
export const selectUsers = payload => ({ type: types.SELECT_USERS, payload });
export const toggleUserDialog = () => ({ type: types.TOGGLE_ADD_TAG_DIALOG });
export const clearUsersSelection = () => ({ type: types.CLEAR_USERS_SELECTION });

export const fetchTagsAction = () => ({ type: types.TAGS_DATA_FETCH });
export const fetchTagsSuccess = payload => ({ type: types.TAGS_DATA_SUCCESS, payload });
export const fetchTagsFailure = () => ({ type: types.TAGS_DATA_FAILURE });

export const fetchTags = () => (
  (dispatch, getState, api) => {
    dispatch(fetchTagsAction());

    return api.getTags()
      .then(response => {
        dispatch(fetchTagsSuccess(response.data.tags));
      })
      .catch(error => {
        dispatch(fetchTagsFailure(error));
      });
  }
);

export const removeUsersTagsToggle = () => ({ type: types.REMOVE_USERS_TAGS_TOGGLE });
export const removeUsersTagsStart = payload => ({ type: types.REMOVE_USERS_TAGS_START, payload });
export const removeUsersTagsSuccess = () => ({ type: types.REMOVE_USERS_TAGS_SUCCESS });
export const removeUsersTagsFailure = () => ({ type: types.REMOVE_USERS_TAGS_FAILURE });

export const removeUsersTags = () => (
  (dispatch, getState, api) => {
    dispatch(removeUsersTagsStart());

    return api.removeUsersTags()
      .then(response => {
        dispatch(removeUsersTagsSuccess(response.data.tags));
      })
      .catch(error => {
        dispatch(removeUsersTagsFailure(error));
      });
  }
);



// WEBPACK FOOTER //
// ./src/redux/tags/actions.js